/*
 * Public API Surface of dop-table
 */

export * from './lib/dop-table.service';
export * from './lib/dop-table.component';
export * from './lib/dop-table.module';
